<template>
  <BaseCard>
    <Flex
      direction="column"
      :gap="0.5"
    >
      <BaseHeading
        size="s"
        :icon="iconName"
        v-test="'card-title'"
      >
        {{ $t(`reports.totals.${title}`) }}
      </BaseHeading>
      <BaseHeading
        v-if="value !== undefined"
        size="xl"
        v-test="'card-value'"
      >
        {{ value }}
      </BaseHeading>
      <BaseText
        v-else
        v-test="'overview-no-results'"
      >
        {{ $t('global.no_results') }}
      </BaseText>
    </Flex>
  </BaseCard>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: Number,
      required: true,
    },
    iconName: {
      type: String,
      required: true,
    },
  },
});
</script>
